import AjaxForm from '../utilities/ajax-form';
import { CheckoutFormNotification } from '../utilities/notifications/checkout-form';
import FormErrors from '../utilities/FormErrors';
import { validateDateOfBirth } from '../utilities/validateDateOfBirth';

export default class SignupForm extends AjaxForm {
   validateInputs() {

    //if(json.success) {

    let errors = [];

    let dateOfBirth = this.form.querySelector('[name="fields[dateOfBirth]"]');


    if(typeof dateOfBirth !=="undefined" && dateOfBirth !==null) {

      if(dateOfBirth.value == "") {
        errors['fields[dateOfBirth]'] = 'Date of Birth cannot be empty.';
      }

      const errorMessage = validateDateOfBirth(dateOfBirth.value);

      if(errorMessage) {
        errors['fields[dateOfBirth]'] = errorMessage;
      }
    }



    //state field validation
    let stateField = this.form.querySelector('[name="fields[state]"]');


    if(typeof stateField !=="undefined" && stateField !==null) {

      if(stateField.value == "") {
        errors['fields[state]'] = 'State cannot be empty.';
      }

    }


    if(Object.keys(errors).length) {
      let Errors = new FormErrors(this.form, errors);

      Errors.addErrorsToFormInputs();

      return false;
    }

    return true;
  }

  handleSuccess(json) {

      let message = 'You have successfully created an account. Redirecting you to The Wine Club.';

      // Check if it's the wine room page. Wineroom pages don't redirect to wineclub.
      if( document.body.classList.contains('page-slug-wine-room-signup') ) {
        message = 'You have successfully created an account.';
      }

      new CheckoutFormNotification({
        type: 'success',
        message: message,
        appendTo: this.form,
        notificationClass: 'js-msg'
      });

      // send 
      gtag('event', 'createaccount', {
        'event': 'createaccount'
      });

      let firstName= '';
      let lastName= '';

      if(this.form.firstName) {
        firstName = this.form.firstName;
      }

      if(this.form.lastName) {
        lastName = this.form.lastName;
      }


      // Push to datalayer - GA tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'user_data': {
          "email": this.form.email.value,
          "first_name": firstName,
          "last_name": lastName,
          "dob": this.form.querySelector('input[name="fields[dateOfBirth]"]')
        }
      });



      gtag('event', 'createaccount_conversion', {
        'send_to': 'AW-'+window.AdConversionIds.conversion_id+'/'+window.AdConversionIds.create_account.label,
        'event_name': window.AdConversionIds.create_account.name,
      });

      setTimeout(function(){
        location = window.location.href
      }, 1500);
      
    //}
  }
};